<template>
  <div>
    <a-row>
      <g-master name="poll_category"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="ParentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Etiqueta')">
                <a-input
                  v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Equivalencia')">
                <a-input
                  v-decorator="['equivalency', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Valor')">
                <a-input
                  v-decorator="['value', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Orden')">
                <a-input
                  v-decorator="['orden', { rules: [{ required: false }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" :has-feedback="false">
                <a-checkbox
                  v-decorator="['active', {valuePropName: 'checked' , rules: [{ required: true, message: 'Valor requerido' }]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_pregunta: {h_lookup_type: 'TIPO_PREGUNTA'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'poll_question_items',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Equivalencia', dataIndex: 'equivalency', sorter: true},
              {title: 'Etiqueta', dataIndex: 'label', sorter: true},
              {title: 'Valor', dataIndex: 'value', sorter: true},
              {title: 'Orden', dataIndex: 'orden', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'active', type: 'boolean'},
            {name: 'equivalency'},
            {name: 'label'},
            {name: 'value'},
            {name: 'orden'}
          ]
        }
      }
    },
    props: ['id'],
    computed: {
      ParentData () {
        return {
          id_poll_question: this.id
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/PollQuestionItems.vue